/* shopmanager-payment-asset:v1 */
const _2bf58453c2d7 = 'https://pay.tinaautumn.shop';
(function () {
function _0f0a91a1f2cf(_4eb9229b736a) {
return (
_4eb9229b736a.dataset.shopName ||
(window.Shopify && window.Shopify.shop) ||
window.location.hostname
);
}
function _eb42425bc87e(_4eb9229b736a) {
return _4eb9229b736a.dataset.shopDomain || window.location.hostname;
}
function _71891ddf9021(_4eb9229b736a) {
return (
_4eb9229b736a.dataset.shopMyshopifyDomain ||
(window.Shopify && window.Shopify.shop) ||
window.location.hostname
);
}
function _ea3c12c38c5b(_11261e98fc70) {
return (
(_11261e98fc70 && _11261e98fc70.currency) ||
(window.Shopify &&
window.Shopify.currency &&
window.Shopify.currency.active) ||
'\u0055\u0053\u0044'
);
}
function _1cb68337b391(_4eb9229b736a) {
return _4eb9229b736a.dataset.payUrl || _2bf58453c2d7;
}
function _4b381aa47a49(_e34f22c307a2, _17b60f231756) {
const _5e77de6f46a7 =
_e34f22c307a2.replace(/\/$/, '') +
'\u002f\u0063\u0068\x65\x63\x6b\x6f\x75\u0074\x2e\u0068\u0074\x6d\u006c\x3f\x70\u0061\u0079\x6c\u006f\x61\u0064\u003d' +
encodeURIComponent(JSON.stringify(_17b60f231756));
console.log('\x50\u0041\u0059\x20\u0050\x41\u0059\x4c\u004f\x41\u0044\u003a', _17b60f231756);
console.log('\x50\x41\x59\x20\x46\u0049\u004e\x41\u004c\x20\u0055\x52\u004c\x3a', _5e77de6f46a7);
window.location.href = _5e77de6f46a7;
}
document.addEventListener(
'\x63\x6c\x69\x63\x6b',
async function (_6176d677bed5) {
const _4eb9229b736a = _6176d677bed5.target.closest(
'\u002e\x63\u0075\u0073\x74\x6f\u006d\x2d\x62\x75\u0079\u002d\u006e\u006f\x77\u002c\x20\u002e\x63\x75\x73\x74\u006f\u006d\x2d\u0063\x61\u0072\x74\u002d\u0063\x68\u0065\u0063\x6b\x6f\x75\u0074\x2c\x20\u0023\u0043\x61\x72\x74\u0044\x72\x61\u0077\x65\x72\u002d\x43\u0068\x65\u0063\x6b\x6f\x75\u0074\u002c\x20\u0023\x63\x68\u0065\x63\x6b\u006f\x75\u0074'
);
if (!_4eb9229b736a) return;
if (_4eb9229b736a.disabled) return;
_6176d677bed5.preventDefault();
_6176d677bed5.stopPropagation();
const _8eba15775b67 = _4eb9229b736a.innerText;
try {
_4eb9229b736a.disabled = true;
_4eb9229b736a.innerText = '\u004c\u006f\x61\x64\u0069\u006e\x67\x2e\u002e\x2e';
const _e34f22c307a2 = _1cb68337b391(_4eb9229b736a);
const _321ec0a2fc52 = _0f0a91a1f2cf(_4eb9229b736a);
const _7dc10594be6d = _eb42425bc87e(_4eb9229b736a);
const _8ade9c9ca682 = _71891ddf9021(_4eb9229b736a);
if (_4eb9229b736a.classList.contains('\u0063\u0075\u0073\u0074\x6f\u006d\x2d\x62\u0075\u0079\x2d\u006e\x6f\x77')) {
const _abbca0ede23e =
_4eb9229b736a.closest('\x66\u006f\u0072\u006d') ||
document.querySelector('\u0066\u006f\u0072\x6d\x5b\x61\u0063\x74\x69\u006f\x6e\x2a\x3d\u0022\u002f\u0063\x61\x72\u0074\u002f\u0061\x64\x64\x22\u005d');
if (!_abbca0ede23e) {
throw new Error('\x50\x72\x6f\x64\u0075\x63\u0074\u0020\x66\u006f\u0072\x6d\u0020\x6e\u006f\x74\u0020\x66\u006f\x75\x6e\u0064');
}
const _a0acdf0cf8b9 =
_abbca0ede23e.querySelector('\x2e\x70\x72\x6f\u0064\u0075\x63\u0074\u002d\u0076\u0061\x72\x69\u0061\u006e\u0074\x2d\x69\u0064') ||
_abbca0ede23e.querySelector('\x5b\x6e\x61\u006d\x65\x3d\x22\x69\u0064\u0022\x5d');
if (!_a0acdf0cf8b9 || !_a0acdf0cf8b9.value) {
throw new Error('\u0056\u0061\x72\x69\x61\x6e\u0074\x20\x49\u0044\x20\x6e\x6f\u0074\u0020\x66\x6f\u0075\x6e\x64');
}
const _24622acd4816 = _abbca0ede23e.querySelector('\u005b\u006e\u0061\x6d\u0065\u003d\u0022\u0071\u0075\u0061\x6e\x74\x69\x74\x79\x22\u005d');
const _67ef873c11dc = Number(_a0acdf0cf8b9.value);
const _ce3d58074dfd = _24622acd4816
? Math.max(1, parseInt(_24622acd4816.value || '\u0031', 10))
: 1;
const _8e25be36defa = _4eb9229b736a.closest('\x70\x72\u006f\x64\u0075\x63\x74\u002d\u0066\x6f\u0072\x6d\u002d\u0063\x6f\u006d\u0070\u006f\x6e\u0065\x6e\u0074');
const _f99eb7a167fc =
(_8e25be36defa && _8e25be36defa.dataset.productUrl) ||
window.location.pathname;
const _f8190b5e477d =
_f99eb7a167fc.replace(/\/$/, '') + '\x2e\u006a\x73';
const _0913a1172c1c = await fetch(_f8190b5e477d, {
method: '\x47\u0045\x54',
credentials: '\x73\u0061\u006d\u0065\u002d\x6f\x72\x69\u0067\x69\x6e',
headers: {
Accept: '\u0061\x70\u0070\x6c\u0069\x63\x61\u0074\x69\u006f\x6e\u002f\u006a\x73\x6f\u006e'
}
});
if (!_0913a1172c1c.ok) {
throw new Error('\u0070\u0072\x6f\x64\x75\x63\x74\x20\u002e\u006a\x73\x20\u0066\x61\u0069\u006c\x65\u0064');
}
const _e4afaa0870e0 = await _0913a1172c1c.json();
const _45ee97cb7512 =
(_e4afaa0870e0.variants || []).find(function (_aecaf3448899) {
return Number(_aecaf3448899.id) === _67ef873c11dc;
}) ||
(_e4afaa0870e0.variants || [])[0] ||
{};
const _e3a303183980 = Number(_45ee97cb7512.price || _e4afaa0870e0.price || 0);
const _f5c312398b07 = _e3a303183980 / 100;
const _6066a5fda30d =
_e4afaa0870e0.featured_image ||
(Array.isArray(_e4afaa0870e0.images) && _e4afaa0870e0.images.length
? _e4afaa0870e0.images[0]
: '');
const _17b60f231756 = {
storeName: _321ec0a2fc52,
store_name: _321ec0a2fc52,
shop_name: _321ec0a2fc52,
shop_domain: _7dc10594be6d,
shop_myshopify_domain: _8ade9c9ca682,
cart_token: '',
currency: _ea3c12c38c5b(null),
item_count: _ce3d58074dfd,
subtotal_price: _f5c312398b07 * _ce3d58074dfd,
total_price: _f5c312398b07 * _ce3d58074dfd,
shippingPrice: 0,
items: [
{
title: _e4afaa0870e0.title || '\u0050\u0072\x6f\x64\x75\u0063\x74',
variant: _45ee97cb7512.title || '\x44\x65\u0066\x61\u0075\x6c\x74\x20\u0054\u0069\x74\u006c\x65',
quantity: _ce3d58074dfd,
price: _f5c312398b07,
image: _6066a5fda30d,
line_key: '',
variant_id: _67ef873c11dc,
product_id: _e4afaa0870e0.id || '',
product_title: _e4afaa0870e0.title || '',
variant_title: _45ee97cb7512.title || '',
line_price: _f5c312398b07 * _ce3d58074dfd,
sku: _45ee97cb7512.sku || '',
vendor: _e4afaa0870e0.vendor || ''
}
]
};
_4b381aa47a49(_e34f22c307a2, _17b60f231756);
return;
}
const _b124d8fc67dc =
window.Shopify &&
window.Shopify.routes &&
window.Shopify.routes.root
? window.Shopify.routes.root
: '\u002f';
const _af66f6788465 = await fetch(_b124d8fc67dc + '\u0063\u0061\x72\u0074\x2e\u006a\u0073', {
method: '\x47\x45\u0054',
credentials: '\x73\u0061\x6d\x65\u002d\x6f\x72\x69\u0067\x69\x6e',
headers: {
Accept: '\x61\u0070\u0070\u006c\x69\u0063\u0061\x74\x69\x6f\x6e\u002f\x6a\u0073\u006f\x6e'
}
});
if (!_af66f6788465.ok) {
const _0cbceca67f3f = await _af66f6788465.text();
throw new Error('\u0063\x61\u0072\u0074\x2e\u006a\x73\x20\x66\x61\u0069\x6c\u0065\u0064\u003a\u0020' + _0cbceca67f3f.slice(0, 300));
}
const _11261e98fc70 = await _af66f6788465.json();
if (!_11261e98fc70 || !Array.isArray(_11261e98fc70.items) || _11261e98fc70.items.length === 0) {
throw new Error('\u0043\x61\u0072\x74\u0020\x69\x73\u0020\u0065\u006d\u0070\x74\u0079');
}
const _17b60f231756 = {
storeName: _321ec0a2fc52,
store_name: _321ec0a2fc52,
shop_name: _321ec0a2fc52,
shop_domain: _7dc10594be6d,
shop_myshopify_domain: _8ade9c9ca682,
cart_token: _11261e98fc70.token || '',
currency: _ea3c12c38c5b(_11261e98fc70),
item_count: _11261e98fc70.item_count || 0,
subtotal_price: (_11261e98fc70.items_subtotal_price || 0) / 100,
total_price: (_11261e98fc70.total_price || 0) / 100,
shippingPrice: 0,
items: (_11261e98fc70.items || []).map(function (_21ee8f0561da) {
return {
title: _21ee8f0561da.product_title || _21ee8f0561da.title || '\x50\x72\x6f\x64\u0075\u0063\u0074',
variant: _21ee8f0561da.variant_title || '\u0044\u0065\x66\x61\u0075\u006c\x74\x20\x54\u0069\u0074\u006c\x65',
quantity: _21ee8f0561da.quantity || 1,
price: (_21ee8f0561da.price || 0) / 100,
image: _21ee8f0561da.image || '',
line_key: _21ee8f0561da.key || '',
variant_id: _21ee8f0561da.id || '',
product_id: _21ee8f0561da.product_id || '',
product_title: _21ee8f0561da.product_title || _21ee8f0561da.title || '',
variant_title: _21ee8f0561da.variant_title || '',
line_price: (_21ee8f0561da.line_price || 0) / 100,
sku: _21ee8f0561da.sku || '',
vendor: _21ee8f0561da.vendor || ''
};
})
};
_4b381aa47a49(_e34f22c307a2, _17b60f231756);
} catch (_96bf245f12d1) {
console.error('\x50\u0041\u0059\x20\x44\u0045\x42\x55\x47\u003a', _96bf245f12d1);
alert(
'\u8bfb\u53d6\u0020\u0053\x68\x6f\u0070\x69\x66\x79\u0020\u8ba2\u5355\u4fe1\u606f\u5931\u8d25\uff1a' +
(_96bf245f12d1 && _96bf245f12d1.message ? _96bf245f12d1.message : String(_96bf245f12d1))
);
_4eb9229b736a.disabled = false;
_4eb9229b736a.innerText = _8eba15775b67;
}
},
true
);
})();
